import { isEnglish } from 'features/applicationPage/helpers';
import { RuleProps } from '../../../types/application.d';
import { CONTENT_QUESTIONS_I, CONTENT_QUESTIONS_II, CONTENT_QUESTIONS_III, CONTENT_QUESTIONS_IV } from './ContentQuestion';
import { APPLICATION_SUBMISSION } from './applicationSubmission';

export const IMPORT_DETAILS = 'import-details';
export const TITLE_DETAILS = 'title-details';
export const GENRE_DETAILS = 'genre-details';
export const OTHER_DETAILS = 'other-details';

// export const SUBTITLES_DETAILS = 'content-iv-details';
export const REMARKS = 'remarks';
export const SECT_TYPE = 'applicant-type-section';
export const SECT_FILER = 'filer-details';
export const SECT_APPLICANT = 'applicant-details';
export const SECT_ADDRESS = 'address-details';
export const ORGANISATION_DETAILS = 'organisation-details';
export const FVG_DOWNLOAD = [
    {
        sectionID: 'fvgDownload',
        sectionName: '',
        fieldList: [
            {
                id: 'download',
                label: '',
                type: 'tableDownload',
                rule: { disabled: true },
                subFields: [
                    {
                        id: 'file-name',
                        header: 'File Name',
                        type: 'dateTime',
                        rule: { disabled: true }
                    },
                    {
                        id: 'category',
                        header: 'Category',
                        type: 'dateTime',
                        rule: { disabled: true }
                    },
                    {
                        id: 'download',
                        header: 'Download',
                        type: 'dateTime',
                        rule: { disabled: true }
                    }
                ],
                span: 12
            }
        ]
    }
];

export const TITLE_DETAILS_FIELDS = [
    {
        sectionID: TITLE_DETAILS,
        sectionName: '',
        fieldList: [
            {
                id: '_title',
                label: 'Title',
                type: 'longText',
                rule: { required: true, charLength: 500 },
                span: 12
            },
            {
                id: 'romanized-title',
                label: 'Romanised Title',
                type: 'text',
                rule: {
                    required: true,
                    charLength: 500,
                    customValidate: ({ currentValue }: RuleProps) => {
                        if (!isEnglish(currentValue as string)) {
                            return 'Only English characters are allowed.';
                        }
                    }
                },
                span: 12
            },
            {
                id: 'publisher',
                label: 'Publisher/Developer',
                type: 'text',
                rule: { required: true, charLength: 500 },
                span: 12
            },
            {
                id: 'year-production',
                label: 'Year of Release',
                type: 'dropdown',
                apiID: 'ReleaseYear',
                rule: {
                    required: true,
                    setValue: ({ currentValue }: RuleProps) => {
                        const result = currentValue === '' ? '2025' : currentValue;
                        return result;
                    }
                }
            },
            {
                id: 'region',
                label: 'Region',
                type: 'multiselectDropdown',
                apiID: 'Region',
                rule: {
                    required: true,
                    customValidate: ({ currentValue }: RuleProps) => {
                        if (Array.isArray(currentValue) && currentValue.length <= 0) {
                            return 'Region is required';
                        }
                        return true;
                    }
                }
            },
            {
                id: 'platform',
                label: 'Platform',
                type: 'checkboxGroup',
                span: 12,
                apiID: 'Platform',
                rule: {
                    required: true,
                    validationMessage: 'Please select at least one of the platforms'
                }
            },
            {
                id: 'others',
                label: 'Others, please specify',
                type: 'text',
                rule: {
                    baseIds: [`${TITLE_DETAILS}-platform`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues && (baseValues[`${TITLE_DETAILS}-platform`] as string)
                                ? (baseValues[`${TITLE_DETAILS}-platform`] as string)?.includes('Others')
                                : false
                        );
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues && (baseValues[`${TITLE_DETAILS}-platform`] as string)
                                ? !(baseValues[`${TITLE_DETAILS}-platform`] as string)?.includes('Others')
                                : true
                        );
                        return result;
                    }
                },
                span: 12
            }
        ]
    }
];

export const GENRE_DETAILS_FIELDS = [
    {
        sectionID: GENRE_DETAILS,
        sectionName: 'Genre',
        sectionNameRequired: true,
        sectionNameSubtitle: 'Select maximum 2',
        fieldList: [
            {
                id: 'action',
                label: 'Action',
                type: 'checkbox'
            },
            {
                id: 'action-sub-genre',
                label: 'Sub genre',
                type: 'dropdown',
                apiID: 'Action',
                returnOffset: true,
                rule: {
                    baseIds: [`${GENRE_DETAILS}-action`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const isHidden = Boolean(baseValues && baseValues[`${GENRE_DETAILS}-action`] !== 'Yes');
                        return isHidden;
                    },
                    required: true
                }
            },
            {
                id: 'adventure',
                label: 'Adventure',
                type: 'checkbox'
            },
            {
                id: 'adventure-sub-genre',
                label: 'Sub genre',
                type: 'dropdown',
                apiID: 'Adventure',
                returnOffset: true,
                rule: {
                    baseIds: [`${GENRE_DETAILS}-adventure`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const isHidden = Boolean(baseValues && baseValues[`${GENRE_DETAILS}-adventure`] !== 'Yes');
                        return isHidden;
                    },
                    required: true
                }
            },
            {
                id: 'fighting',
                label: 'Fighting',
                type: 'checkbox'
            },
            {
                id: 'fighting-sub-genre',
                label: 'Sub genre',
                type: 'dropdown',
                apiID: 'Fighting',
                returnOffset: true,
                rule: {
                    baseIds: [`${GENRE_DETAILS}-fighting`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const isHidden = Boolean(baseValues && baseValues[`${GENRE_DETAILS}-fighting`] !== 'Yes');
                        return isHidden;
                    },
                    required: true
                }
            },
            {
                id: 'puzzle',
                label: 'Puzzle',
                type: 'checkbox'
            },
            {
                id: 'offset'
            },
            {
                id: 'racing',
                label: 'Racing',
                type: 'checkbox'
            },
            {
                id: 'racing-sub-genre',
                label: 'Sub genre',
                type: 'dropdown',
                apiID: 'Racing',
                returnOffset: true,
                rule: {
                    baseIds: [`${GENRE_DETAILS}-racing`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const isHidden = Boolean(baseValues && baseValues[`${GENRE_DETAILS}-racing`] !== 'Yes');
                        return isHidden;
                    },
                    required: true
                }
            },
            {
                id: 'rpg',
                label: 'Role Playing Games (RPG)',
                type: 'checkbox'
            },
            {
                id: 'rpg-sub-genre',
                label: 'Sub genre',
                type: 'dropdown',

                apiID: 'Role Playing Games(RPG)',
                returnOffset: true,
                rule: {
                    baseIds: [`${GENRE_DETAILS}-rpg`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const isHidden = Boolean(baseValues && baseValues[`${GENRE_DETAILS}-rpg`] !== 'Yes');
                        return isHidden;
                    },
                    required: true
                }
            },
            {
                id: 'simulation',
                label: 'Simulation',
                type: 'checkbox'
            },
            {
                id: 'simulation-sub-genre',
                label: 'Sub genre',
                type: 'dropdown',
                apiID: 'Simulation',
                returnOffset: true,
                rule: {
                    baseIds: [`${GENRE_DETAILS}-simulation`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const isHidden = Boolean(baseValues && baseValues[`${GENRE_DETAILS}-simulation`] !== 'Yes');
                        return isHidden;
                    },
                    required: true
                }
            },
            {
                id: 'sports',
                label: 'Sports',
                type: 'checkbox'
            },
            {
                id: 'offset-1'
            },
            {
                id: 'strategy',
                label: 'Strategy',
                type: 'checkbox'
            },
            {
                id: 'strategy-sub-genre',
                type: 'dropdown',
                label: 'Sub genre',
                apiID: 'Strategy',
                returnOffset: true,
                rule: {
                    baseIds: [`${GENRE_DETAILS}-strategy`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const isHidden = Boolean(baseValues && baseValues[`${GENRE_DETAILS}-strategy`] !== 'Yes');
                        return isHidden;
                    },
                    required: true
                }
            },
            {
                id: 'other',
                label: 'Other',
                type: 'checkbox'
            },
            {
                id: 'other-sub-genre',
                type: 'dropdown',
                label: 'Sub genre',
                apiID: 'Other',
                returnOffset: true,
                rule: {
                    baseIds: [`${GENRE_DETAILS}-other`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const isHidden = Boolean(baseValues && baseValues[`${GENRE_DETAILS}-other`] !== 'Yes');
                        return isHidden;
                    },
                    required: true
                }
            },
            {
                id: 'genre',
                label: 'Genre',
                type: 'checkbox',
                rule: {
                    baseIds: [
                        `${GENRE_DETAILS}-action`,
                        `${GENRE_DETAILS}-adventure`,
                        `${GENRE_DETAILS}-fighting`,
                        `${GENRE_DETAILS}-puzzle`,
                        `${GENRE_DETAILS}-racing`,
                        `${GENRE_DETAILS}-rpg`,
                        `${GENRE_DETAILS}-simulation`,
                        `${GENRE_DETAILS}-sports`,
                        `${GENRE_DETAILS}-strategy`,
                        `${GENRE_DETAILS}-other`
                    ],
                    required: ({ baseValues }: RuleProps) => {
                        const genres = [
                            baseValues?.[`${GENRE_DETAILS}-action`],
                            baseValues?.[`${GENRE_DETAILS}-adventure`],
                            baseValues?.[`${GENRE_DETAILS}-fighting`],
                            baseValues?.[`${GENRE_DETAILS}-puzzle`],
                            baseValues?.[`${GENRE_DETAILS}-racing`],
                            baseValues?.[`${GENRE_DETAILS}-rpg`],
                            baseValues?.[`${GENRE_DETAILS}-simulation`],
                            baseValues?.[`${GENRE_DETAILS}-sports`],
                            baseValues?.[`${GENRE_DETAILS}-strategy`],
                            baseValues?.[`${GENRE_DETAILS}-other`]
                        ];

                        const noGenre = genres.filter((x) => x === 'Yes').length <= 0;

                        if (noGenre) {
                            return 'At least 1 genre is required';
                        }
                    },
                    customValidate: ({ baseValues }: RuleProps) => {
                        const genres = [
                            baseValues?.[`${GENRE_DETAILS}-action`],
                            baseValues?.[`${GENRE_DETAILS}-adventure`],
                            baseValues?.[`${GENRE_DETAILS}-fighting`],
                            baseValues?.[`${GENRE_DETAILS}-puzzle`],
                            baseValues?.[`${GENRE_DETAILS}-racing`],
                            baseValues?.[`${GENRE_DETAILS}-rpg`],
                            baseValues?.[`${GENRE_DETAILS}-simulation`],
                            baseValues?.[`${GENRE_DETAILS}-sports`],
                            baseValues?.[`${GENRE_DETAILS}-strategy`],
                            baseValues?.[`${GENRE_DETAILS}-other`]
                        ];

                        const maxGenre = genres.filter((x) => x === 'Yes').length >= 3;

                        if (maxGenre) {
                            return 'Select maximum 2';
                        }
                    }
                }
            }
        ]
    }
];

export const OTHER_DETAILS_FIELDS = [
    {
        sectionID: OTHER_DETAILS,
        sectionName: 'Rating By Other Rating Boards',
        sectionNameRequired: true,
        fieldList: [
            {
                id: 'ratings',
                label: '',
                type: 'checkboxGroup',
                span: 8,
                rule: {
                    baseIds: [`${OTHER_DETAILS}-ratings`],
                    required: true,
                    disabled: ({ baseValues, currentValue }: RuleProps) => {
                        const result = Boolean(
                            baseValues && (baseValues[`${OTHER_DETAILS}-ratings`] as string)
                                ? (baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('No Rating Available')
                                : false
                        );
                        return result;
                    },
                    validationMessage: 'Please select at least one of the ratings'
                },
                options: [
                    {
                        optID: 'No Rating Available',
                        optLabel: 'No Rating Available'
                    },
                    {
                        optID: 'ESRB Rating',
                        optLabel: 'ESRB Rating'
                    },
                    {
                        optID: 'PEGI Rating',
                        optLabel: 'PEGI Rating'
                    },
                    {
                        optID: 'ACB Rating',
                        optLabel: 'ACB Rating'
                    },
                    {
                        optID: 'CERO Rating',
                        optLabel: 'CERO Rating'
                    },
                    {
                        optID: 'Others',
                        optLabel: 'Others'
                    }
                ]
            },
            {
                id: 'esrb-rating',
                label: 'ESRB Rating',
                type: 'dropdown',
                apiID: 'ESRB Rating',
                rule: {
                    baseIds: [`${OTHER_DETAILS}-ratings`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            ((baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('ESRB Rating') ||
                                !(baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('No Rating Available'))
                        );
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            (!(baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('ESRB Rating') ||
                                (baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('No Rating Available'))
                        );
                        return result;
                    }
                },
                span: 7
            },
            {
                id: 'esrb-consumer-advice',
                label: 'Consumer Advice',
                rule: {
                    baseIds: [`${OTHER_DETAILS}-ratings`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            (!(baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('ESRB Rating') ||
                                (baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('No Rating Available'))
                        );
                        return result;
                    },
                    charLength: 500
                },
                type: 'longText',
                span: 12
            },
            {
                id: 'pegi-rating',
                label: 'PEGI Rating',
                type: 'dropdown',
                apiID: 'PEGI Rating',
                rule: {
                    baseIds: [`${OTHER_DETAILS}-ratings`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            ((baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('PEGI Rating') ||
                                !(baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('No Rating Available'))
                        );
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            (!(baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('PEGI Rating') ||
                                (baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('No Rating Available'))
                        );
                        return result;
                    }
                },
                span: 7
            },
            {
                id: 'pegi-consumer-advice',
                label: 'Consumer Advice',
                type: 'longText',
                rule: {
                    baseIds: [`${OTHER_DETAILS}-ratings`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            (!(baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('PEGI Rating') ||
                                (baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('No Rating Available'))
                        );
                        return result;
                    },
                    charLength: 500
                },
                span: 12
            },
            {
                id: 'acb-rating',
                label: 'ACB Rating',
                type: 'dropdown',
                apiID: 'ACB Rating',
                rule: {
                    baseIds: [`${OTHER_DETAILS}-ratings`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            ((baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('ACB Rating') ||
                                !(baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('No Rating Available'))
                        );
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            (!(baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('ACB Rating') ||
                                (baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('No Rating Available'))
                        );
                        return result;
                    }
                },
                span: 7
            },
            {
                id: 'acb-consumer-advice',
                label: 'Consumer Advice',
                type: 'longText',
                rule: {
                    baseIds: [`${OTHER_DETAILS}-ratings`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            (!(baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('ACB Rating') ||
                                (baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('No Rating Available'))
                        );
                        return result;
                    },
                    charLength: 500
                },
                span: 12
            },
            {
                id: 'cero-rating',
                label: 'CERO Rating',
                type: 'dropdown',
                apiID: 'CERO Rating',
                rule: {
                    baseIds: [`${OTHER_DETAILS}-ratings`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            ((baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('CERO Rating') ||
                                !(baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('No Rating Available'))
                        );
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            (!(baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('CERO Rating') ||
                                (baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('No Rating Available'))
                        );
                        return result;
                    }
                },
                span: 7
            },
            {
                id: 'cero-consumer-advice',
                label: 'Consumer Advice',
                type: 'longText',
                rule: {
                    baseIds: [`${OTHER_DETAILS}-ratings`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            (!(baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('CERO Rating') ||
                                (baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('No Rating Available'))
                        );
                        return result;
                    },
                    charLength: 500
                },
                span: 12
            },
            {
                id: 'others',
                label: 'Others, please specify',
                type: 'longText',
                rule: {
                    baseIds: [`${OTHER_DETAILS}-ratings`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            ((baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('Others') ||
                                !(baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('No Rating Available'))
                        );
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            (!(baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('Others') ||
                                (baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('No Rating Available'))
                        );
                        return result;
                    },
                    charLength: 500
                },
                span: 12
            }
        ]
    }
];

export const VIDEOGAMES_DETAILS_FIELDS = [
    {
        sectionID: TITLE_DETAILS,
        sectionName: 'Title Details',
        fieldList: [
            {
                id: '_title',
                label: 'Title',
                type: 'text',
                rule: { required: true },
                span: 12
            },
            {
                id: 'romanized-title',
                label: 'Romanised Title',
                type: 'text',
                rule: {
                    required: true,
                    customValidate: ({ currentValue }: RuleProps) => {
                        if (!isEnglish(currentValue as string)) {
                            return 'Only English characters are allowed.';
                        }
                    }
                },
                span: 12
            },
            {
                id: 'publisher',
                label: 'Publisher/Developer',
                type: 'text',
                rule: { required: true },
                span: 12
            },
            {
                id: 'year-production',
                label: 'Year of Release',
                type: 'dropdown',
                apiID: 'ReleaseYear',
                rule: { required: true }
            },
            {
                id: 'region',
                label: 'Region',
                type: 'multiselectDropdown',
                apiID: 'Region',
                rule: {
                    required: true,
                    customValidate: ({ currentValue }: RuleProps) => {
                        if (Array.isArray(currentValue) && currentValue.length <= 0) {
                            return 'Region is required';
                        }
                        return true;
                    }
                }
            },
            {
                id: 'platform',
                label: 'Platform',
                type: 'checkboxGroup',
                span: 12,
                apiID: 'Platform',
                rule: {
                    required: true,
                    validationMessage: 'Please select at least one of the platforms'
                }
            },
            {
                id: 'others',
                label: 'Others, please specify',
                type: 'text',
                rule: {
                    baseIds: [`${TITLE_DETAILS}-platform`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues && (baseValues[`${TITLE_DETAILS}-platform`] as string)
                                ? baseValues[`${TITLE_DETAILS}-platform`].toString().includes('Others')
                                : false
                        );
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues && (baseValues[`${TITLE_DETAILS}-platform`] as string)
                                ? !baseValues[`${TITLE_DETAILS}-platform`].toString().includes('Others')
                                : true
                        );
                        return result;
                    }
                },
                span: 12
            }
        ]
    },
    {
        sectionID: GENRE_DETAILS,
        sectionName: 'Genre',
        fieldList: [
            {
                id: 'action',
                label: 'Action',
                type: 'checkbox',
                span: 2
            },
            {
                id: 'action-sub-genre',
                label: 'Action Sub Genre',
                type: 'dropdown',
                span: 4,
                apiID: 'Action',
                returnOffset: true,
                rule: {
                    baseIds: [`${GENRE_DETAILS}-action`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const isHidden = Boolean(baseValues && baseValues[`${GENRE_DETAILS}-action`] !== 'Yes');
                        return isHidden;
                    },
                    required: true
                }
            },
            {
                id: 'adventure',
                label: 'Adventure',
                type: 'checkbox',
                span: 2
            },
            {
                id: 'adventure-sub-genre',
                label: 'Adventure Sub Genre',
                type: 'dropdown',
                span: 4,
                apiID: 'Adventure',
                returnOffset: true,
                rule: {
                    baseIds: [`${GENRE_DETAILS}-adventure`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const isHidden = Boolean(baseValues && baseValues[`${GENRE_DETAILS}-adventure`] !== 'Yes');
                        return isHidden;
                    },
                    required: true
                }
            },
            {
                id: 'fighting',
                label: 'Fighting',
                type: 'checkbox',
                span: 2
            },
            {
                id: 'fighting-sub-genre',
                label: 'Fighting Sub Genre',
                type: 'dropdown',
                span: 4,
                apiID: 'Fighting',
                returnOffset: true,
                rule: {
                    baseIds: [`${GENRE_DETAILS}-fighting`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const isHidden = Boolean(baseValues && baseValues[`${GENRE_DETAILS}-fighting`] !== 'Yes');
                        return isHidden;
                    },
                    required: true
                }
            },
            {
                id: 'puzzle',
                label: 'Puzzle',
                type: 'checkbox',
                span: 2
            },
            {
                id: 'offset',
                span: 4
            },
            {
                id: 'racing',
                label: 'Racing',
                type: 'checkbox',
                span: 2
            },
            {
                id: 'racing-sub-genre',
                label: 'Racing Sub Genre',
                type: 'dropdown',
                span: 4,
                apiID: 'Racing',
                returnOffset: true,
                rule: {
                    baseIds: [`${GENRE_DETAILS}-racing`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const isHidden = Boolean(baseValues && baseValues[`${GENRE_DETAILS}-racing`] !== 'Yes');
                        return isHidden;
                    },
                    required: true
                }
            },
            {
                id: 'rpg',
                label: 'Role Playing Games (RPG)',
                type: 'checkbox',
                span: 2
            },
            {
                id: 'rpg-sub-genre',
                label: 'RPG Sub Genre',
                type: 'dropdown',
                span: 4,
                apiID: 'Role Playing Games(RPG)',
                returnOffset: true,
                rule: {
                    baseIds: [`${GENRE_DETAILS}-rpg`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const isHidden = Boolean(baseValues && baseValues[`${GENRE_DETAILS}-rpg`] !== 'Yes');
                        return isHidden;
                    },
                    required: true
                }
            },
            {
                id: 'simulation',
                label: 'Simulation',
                type: 'checkbox',
                span: 2
            },
            {
                id: 'simulation-sub-genre',
                label: 'Simulation Sub Genre',
                type: 'dropdown',
                span: 4,
                apiID: 'Simulation',
                returnOffset: true,
                rule: {
                    baseIds: [`${GENRE_DETAILS}-simulation`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const isHidden = Boolean(baseValues && baseValues[`${GENRE_DETAILS}-simulation`] !== 'Yes');
                        return isHidden;
                    },
                    required: true
                }
            },
            {
                id: 'sports',
                label: 'Sports',
                type: 'checkbox',
                span: 2
            },
            {
                id: 'offset-1',
                span: 4
            },
            {
                id: 'other',
                label: 'Other',
                type: 'checkbox',
                span: 2
            },
            {
                id: 'other-sub-genre',
                type: 'dropdown',
                label: 'Other Sub Genre',
                span: 4,
                apiID: 'Other',
                returnOffset: true,
                rule: {
                    baseIds: [`${GENRE_DETAILS}-other`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const isHidden = Boolean(baseValues && baseValues[`${GENRE_DETAILS}-other`] !== 'Yes');
                        return isHidden;
                    },
                    required: true
                }
            },
            {
                id: 'strategy',
                label: 'Strategy',
                type: 'checkbox',
                span: 2
            },
            {
                id: 'strategy-sub-genre',
                type: 'dropdown',
                label: 'Strategy Sub Genre',
                span: 4,
                apiID: 'Strategy',
                returnOffset: true,
                rule: {
                    baseIds: [`${GENRE_DETAILS}-strategy`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const isHidden = Boolean(baseValues && baseValues[`${GENRE_DETAILS}-strategy`] !== 'Yes');
                        return isHidden;
                    },
                    required: true
                }
            },
            {
                id: 'genre',
                label: 'Genre',
                type: 'checkbox',
                rule: {
                    baseIds: [
                        `${GENRE_DETAILS}-action`,
                        `${GENRE_DETAILS}-adventure`,
                        `${GENRE_DETAILS}-fighting`,
                        `${GENRE_DETAILS}-puzzle`,
                        `${GENRE_DETAILS}-racing`,
                        `${GENRE_DETAILS}-rpg`,
                        `${GENRE_DETAILS}-simulation`,
                        `${GENRE_DETAILS}-sports`,
                        `${GENRE_DETAILS}-other`,
                        `${GENRE_DETAILS}-strategy`
                    ],
                    required: ({ baseValues }: RuleProps) => {
                        const genres = [
                            baseValues?.[`${GENRE_DETAILS}-action`],
                            baseValues?.[`${GENRE_DETAILS}-adventure`],
                            baseValues?.[`${GENRE_DETAILS}-fighting`],
                            baseValues?.[`${GENRE_DETAILS}-puzzle`],
                            baseValues?.[`${GENRE_DETAILS}-racing`],
                            baseValues?.[`${GENRE_DETAILS}-rpg`],
                            baseValues?.[`${GENRE_DETAILS}-simulation`],
                            baseValues?.[`${GENRE_DETAILS}-sports`],
                            baseValues?.[`${GENRE_DETAILS}-other`],
                            baseValues?.[`${GENRE_DETAILS}-strategy`]
                        ];

                        const noGenre = genres.filter((x) => x === 'Yes').length <= 0;

                        if (noGenre) {
                            return 'Please select atleast 1 or 2 genres';
                        }
                    },
                    customValidate: ({ baseValues }: RuleProps) => {
                        const genres = [
                            baseValues?.[`${GENRE_DETAILS}-action`],
                            baseValues?.[`${GENRE_DETAILS}-adventure`],
                            baseValues?.[`${GENRE_DETAILS}-fighting`],
                            baseValues?.[`${GENRE_DETAILS}-puzzle`],
                            baseValues?.[`${GENRE_DETAILS}-racing`],
                            baseValues?.[`${GENRE_DETAILS}-rpg`],
                            baseValues?.[`${GENRE_DETAILS}-simulation`],
                            baseValues?.[`${GENRE_DETAILS}-sports`],
                            baseValues?.[`${GENRE_DETAILS}-other`],
                            baseValues?.[`${GENRE_DETAILS}-strategy`]
                        ];

                        const maxGenre = genres.filter((x) => x === 'Yes').length >= 3;

                        if (maxGenre) {
                            return 'Maximum of 2 genres  only';
                        }
                    }
                },
                span: 12
            }
        ]
    },
    {
        sectionID: OTHER_DETAILS,
        sectionName: 'Rating By Other Rating Boards',
        fieldList: [
            {
                id: 'ratings',
                label: '',
                type: 'checkboxGroup',
                // isRowDisplay: true,
                span: 12,
                rule: {
                    baseIds: [`${OTHER_DETAILS}-ratings`],
                    required: true,
                    validationMessage: 'Please select at least one of the ratings',
                    disabled: ({ baseValues, currentValue }: RuleProps) => {
                        const result = Boolean(
                            baseValues && (baseValues[`${OTHER_DETAILS}-ratings`] as string)
                                ? (baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('No Rating Available')
                                : false
                        );
                        return result;
                    }
                },
                options: [
                    {
                        optID: 'No Rating Available',
                        optLabel: 'No Rating Available'
                    },
                    {
                        optID: 'ESRB Rating',
                        optLabel: 'ESRB Rating'
                    },
                    {
                        optID: 'PEGI Rating',
                        optLabel: 'PEGI Rating'
                    },
                    {
                        optID: 'ACB Rating',
                        optLabel: 'ACB Rating'
                    },
                    {
                        optID: 'CERO Rating',
                        optLabel: 'CERO Rating'
                    },
                    {
                        optID: 'Others',
                        optLabel: 'Others'
                    }
                ]
            },
            {
                id: 'esrb-rating',
                label: 'ESRB Rating',
                type: 'dropdown',
                apiID: 'ESRB Rating',
                rule: {
                    baseIds: [`${OTHER_DETAILS}-ratings`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            ((baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('ESRB Rating') ||
                                !(baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('No Rating Available'))
                        );
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            (!(baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('ESRB Rating') ||
                                (baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('No Rating Available'))
                        );
                        return result;
                    }
                },
                span: 6
            },
            {
                id: 'esrb-consumer-advice',
                label: 'Consumer Advice',
                rule: {
                    baseIds: [`${OTHER_DETAILS}-ratings`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            (!(baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('ESRB Rating') ||
                                (baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('No Rating Available'))
                        );
                        return result;
                    }
                },
                type: 'longText',
                span: 6
            },
            {
                id: 'pegi-rating',
                label: 'PEGI Rating',
                type: 'dropdown',
                apiID: 'PEGI Rating',
                rule: {
                    baseIds: [`${OTHER_DETAILS}-ratings`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            ((baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('PEGI Rating') ||
                                !(baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('No Rating Available'))
                        );
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            (!(baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('PEGI Rating') ||
                                (baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('No Rating Available'))
                        );
                        return result;
                    }
                },
                span: 6
            },
            {
                id: 'pegi-consumer-advice',
                label: 'Consumer Advice',
                type: 'longText',
                rule: {
                    baseIds: [`${OTHER_DETAILS}-ratings`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            (!(baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('PEGI Rating') ||
                                (baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('No Rating Available'))
                        );
                        return result;
                    }
                },
                span: 6
            },
            {
                id: 'acb-rating',
                label: 'ACB Rating',
                type: 'dropdown',
                apiID: 'ACB Rating',
                rule: {
                    baseIds: [`${OTHER_DETAILS}-ratings`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            ((baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('ACB Rating') ||
                                !(baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('No Rating Available'))
                        );
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            (!(baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('ACB Rating') ||
                                (baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('No Rating Available'))
                        );
                        return result;
                    }
                },
                span: 6
            },
            {
                id: 'acb-consumer-advice',
                label: 'Consumer Advice',
                type: 'longText',
                rule: {
                    baseIds: [`${OTHER_DETAILS}-ratings`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            (!(baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('ACB Rating') ||
                                (baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('No Rating Available'))
                        );
                        return result;
                    }
                },
                span: 6
            },
            {
                id: 'cero-rating',
                label: 'CERO Rating',
                type: 'dropdown',
                apiID: 'CERO Rating',
                rule: {
                    baseIds: [`${OTHER_DETAILS}-ratings`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            ((baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('CERO Rating') ||
                                !(baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('No Rating Available'))
                        );
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            (!(baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('CERO Rating') ||
                                (baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('No Rating Available'))
                        );
                        return result;
                    }
                },
                span: 6
            },
            {
                id: 'cero-consumer-advice',
                label: 'Consumer Advice',
                type: 'longText',
                rule: {
                    baseIds: [`${OTHER_DETAILS}-ratings`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            (!(baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('CERO Rating') ||
                                (baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('No Rating Available'))
                        );
                        return result;
                    }
                },
                span: 6
            },
            {
                id: 'others',
                label: 'Others, please specify',
                type: 'longText',
                rule: {
                    baseIds: [`${OTHER_DETAILS}-ratings`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            ((baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('Others') ||
                                !(baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('No Rating Available'))
                        );
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            (!(baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('Others') ||
                                (baseValues[`${OTHER_DETAILS}-ratings`] as string)?.includes('No Rating Available'))
                        );
                        return result;
                    }
                },
                span: 12
            }
        ]
    },
    {
        sectionID: CONTENT_QUESTIONS_I,
        sectionName: 'Content Question I',
        fieldList: [
            {
                id: 'question',
                options: [
                    { optID: 'Yes', optLabel: 'Yes' },
                    { optID: 'No', optLabel: 'No' }
                ],
                label: 'Q1. Does the game contain any of the following materials?',
                display: 'inline',
                type: 'radio',
                span: 12,
                rule: {
                    required: true
                }
            },
            {
                id: 'heading-1',
                type: 'label',
                variant: 'h4',
                label: '- Gambling',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'body-1',
                type: 'label',
                label: '- This refers to betting, gambling games or other games of chance that are normally played for money. It includes titles which are instructional and teaches a player how to play those games. (This does not cover games where gambling is no the main feature but occurs as minor part of the storyline, eg. Mini-games in RPGs.)',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'heading-2',
                type: 'label',
                variant: 'h4',
                label: '- Religious content / elements',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'body-2',
                type: 'label',
                label: '- This refers to games containing religious content or elements. The religious content could be either a major or minor element in the game.',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'heading-3',
                type: 'label',
                variant: 'h4',
                label: '- Terrorism',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'body-3',
                type: 'label',
                label: '- This refers to games with terrorism as part of its plot.',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'heading-4',
                type: 'label',
                variant: 'h4',
                label: '- Politics',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'body-4',
                type: 'label',
                label: '- This refers to games where politics or political situations are a feature of the game.',
                span: 12,
                rule: {
                    previewHidden: true
                }
            }
        ]
    },
    {
        sectionID: CONTENT_QUESTIONS_II,
        sectionName: 'Content Question II',
        fieldList: [
            {
                id: 'question',
                options: [
                    { optID: 'Yes', optLabel: 'Yes' },
                    { optID: 'No', optLabel: 'No' }
                ],
                label: 'Q2. Does the game contain any of the following materials?',
                display: 'inline',
                type: 'radio',
                span: 12,
                rule: {
                    required: true
                }
            },
            {
                id: 'heading-1',
                type: 'label',
                variant: 'h4',
                label: '- Material which may undermine national interest',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'body-1',
                type: 'label',
                label: '- This refers to content which may undermine public order or social stability',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'heading-2',
                type: 'label',
                variant: 'h4',
                label: '- Material which is likely to offend a race or religion in Singapore',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'body-2',
                type: 'label',
                label: '- This refers to content which may cause misunderstanding, incite hatred or strife among religious groups. It includes the use of religious symbols or figures which may be blasphemous',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'heading-3',
                type: 'label',
                variant: 'h4',
                label: '- Material that deals with alternative lifestyle, depict sexual violence, explicit sexual activity, or deviant sexual activity',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'body-3',
                type: 'label',
                label: `- Explicit sexual activity refers to content depicting actual sexual intercourse and scenes of couple copulating where genitals may or may not be visible. 
                            - Deviant sexual activity refers to, but are not limited to activities such as necrophilia, bestiality, pedophilia, and incest. 
                            - Alternative lifestyles include, but is not limited to homosexuality, wife-swapping, swinging.`,
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'heading-4',
                type: 'label',
                variant: 'h4',
                label: '- Material that depicts criminal activities with clear instructional details',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'body-4',
                type: 'label',
                label: '- This refers to content which may show how the offences can be carried out, e.g. step-by-step guide to making a bomb.',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'heading-5',
                type: 'label',
                variant: 'h4',
                label: '- Material which depict sadistic and cruel violence to human-like characters',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'body-5',
                type: 'label',
                label: '- This refers to content with a sadistic intent where the acts of violence are detailed, such as horrific, brutal or repulsive depictions of death, injury, dismemberment or torture and other methods of bringing severe pain or injury to the recipient. These violent acts are often accompanied by large amount of blood and gore.',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'heading-6',
                type: 'label',
                variant: 'h4',
                label: '- Exploitative nudity',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'body-6',
                type: 'label',
                label: '- This refers to instances where male and female nudity where gentials are clearly depicted. This would include content where the presentation of nudity is exploitative and is a constant feature.',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'heading-7',
                type: 'label',
                variant: 'h4',
                label: '- Instructive details of consumption of illegal drugs or content that encourages drug use',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'body-7',
                type: 'label',
                label: '- This refers to content which serves as a step-by-step guide to the preparation and consumption of illegal drugs.- The game glamorises drug use and encourages the use of illegal drug.',
                span: 12,
                rule: {
                    previewHidden: true
                }
            }
        ]
    },
    {
        sectionID: CONTENT_QUESTIONS_III,
        sectionName: 'Content Question III',
        fieldList: [
            {
                id: 'question',
                options: [
                    { optID: 'Yes', optLabel: 'Yes' },
                    { optID: 'No', optLabel: 'No' }
                ],
                label: 'Q3. Does the game contain any of the following materials?',
                display: 'inline',
                type: 'radio',
                span: 12,
                rule: {
                    required: true
                }
            },
            {
                id: 'heading-1',
                type: 'label',
                variant: 'h4',
                label: '- Content that requires the player to engage in illegal activities or play the role of a criminal, but does not have instructional details',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'body-1',
                type: 'label',
                label: "- The theme of these games involves the player's participation in crime or other illegal activities. Such games will allow a player to commit crime as part of their main mission or encourage the player to build up a criminal empire. This does not include comic or cartoon-like depiction of crime capers.",
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'heading-2',
                type: 'label',
                variant: 'h4',
                label: '- Depictions of realistic violence such as killing or causing serious injury to human-like characters',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'body-2',
                type: 'label',
                label: "- Such games involve the killing and causing of injury to human-like characters where the depiction of violence is realistic, i.e. body parts being severed and other methods of causing death, severe pain or injury, are presented in clear detail, e.g. a person's body splits into two when slashed, with spraying of blood/organs. The action may involve motiveless and random killing or injury to characters such as pedestrians in the streets.",
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'heading-3',
                type: 'label',
                variant: 'h4',
                label: '- Materials which depicts sexual activity',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'body-3',
                type: 'label',
                label: '- This refers to content where depiction of sexual activity with some nudity occurs. Homosexual activity should be limited to kissing and hugging.',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'heading-4',
                type: 'label',
                variant: 'h4',
                label: '- Non-exploitative nudity or materials which could be sexually titillating',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'body-4',
                type: 'label',
                label: '- Non-exploitative nudity refers to instances where nudity is not the main feature of the game. This includes depiction of topless nudity as well as occasional frontal nudity which is human-like. Nudity in the game may not have the intent to titillate. Sexually titillating materials include moving or still images (including partial nudity) that are sexually suggestive. Such materials are those that use images, for example scantily-clad women, in a manner that is titillating.',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'heading-5',
                type: 'label',
                variant: 'h4',
                label: '- Strong and frequent coarse language',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'body-5',
                type: 'label',
                label: '- This refers to strong coarse language used frequently in the game. It includes sexual expletives such as "cunt" and "cocksucker".',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'heading-6',
                type: 'label',
                variant: 'h4',
                label: '- Realistic depiction of frequent illegal drug use',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'body-6',
                type: 'label',
                label: '- The primary intent should not encourage the consumption of drug to achieve success, e.g. kill the enemy or to complete the level. Realistic depiction of drug use refers to the depiction of real-life substance abuse but does not include instructive details. For example, showing a character injecting drug into his arm is allowed but the full method of preparation should not be permitted',
                span: 12,
                rule: {
                    previewHidden: true
                }
            }
        ]
    },
    {
        sectionID: CONTENT_QUESTIONS_IV,
        sectionName: 'Content Question IV',
        fieldList: [
            {
                id: 'question',
                options: [
                    { optID: 'Yes', optLabel: 'Yes' },
                    { optID: 'No', optLabel: 'No' }
                ],
                label: 'Q4. Does the game contain any of the following materials?',
                display: 'inline',
                type: 'radio',
                span: 12,
                rule: {
                    required: true
                }
            },
            {
                id: 'heading-1',
                type: 'label',
                variant: 'h4',
                label: '- Depictions of moderate violence such as killing or causing injury to human-like characters',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'body-1',
                type: 'label',
                label: '- This include games where all or the majority of the gameplay involve violence with depiction of blood. It includes shooting games where a moderate amount of blood is depicted. The level of details of injury or killing is kept to a minimum. This includes fighting games which depicts some amount of blood and gore.',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'heading-2',
                type: 'label',
                variant: 'h4',
                label: '- Images or words that imply sexual activity',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'body-2',
                type: 'label',
                label: '- This refers to sexual innuendos relating to sexual intercourse or foreplay, and.can consist of words and/or activity. It includes occasions where it is clearly implied that the characters are engaging in sexual activity.',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'heading-3',
                type: 'label',
                variant: 'h4',
                label: '- Nudity in a non-sexual context',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'body-3',
                type: 'label',
                label: '- This refers to nudity which does"ot contain details, e.g. no nipples, genitalia or pubic region (includes hair).',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'heading-4',
                type: 'label',
                variant: 'h4',
                label: '- Depictions of materials which could be mildly suggestive',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'body-4',
                type: 'label',
                label: '- These include moving or still images which use scantily-clad women in bikinis or lingerie in a manner which could be sexually suggestive.',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'heading-5',
                type: 'label',
                variant: 'h4',
                label: '- Some coarse language',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'body-5',
                type: 'label',
                label: '- This refers to infrequent coarse language use. Use of occasional expletives such as "fuck" as a swear word is permissible.',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'heading-6',
                type: 'label',
                variant: 'h4',
                label: '- Depictions of drug use or substance abuse',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'body-6',
                type: 'label',
                label: '- This refers to any illegal drug use or substance abuse which may be implied.',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'heading-7',
                type: 'label',
                variant: 'h4',
                label: '- Depictions of horror',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'body-7',
                type: 'label',
                label: '- This refers to depictions of frightening and disturbing sequences, or any abhorrent phenomena, whether natural or pertaining to the supernatural.',
                span: 12,
                rule: {
                    previewHidden: true
                }
            }
        ]
    },
    {
        sectionID: APPLICATION_SUBMISSION,
        sectionName: 'Application Submission',
        fieldList: [
            {
                id: 'tentative-rating',
                label: 'Tentative Rating',
                type: 'text',
                rule: {
                    required: true,
                    hidden: true
                }
            },
            {
                id: 'format',
                label: 'Format',
                type: 'dropdown',
                apiID: 'FormatsAvailable',
                hasLabelInfo: true,
                rule: {
                    baseIds: [`${APPLICATION_SUBMISSION}-tentative-rating`],
                    required: true,
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${APPLICATION_SUBMISSION}-tentative-rating`] === 'General');
                        return result;
                    }
                }
            },
            {
                id: 'online-link',
                label: 'Online Link',
                type: 'text',
                rule: {
                    baseIds: [`${APPLICATION_SUBMISSION}-format`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = !Boolean(baseValues && baseValues[`${APPLICATION_SUBMISSION}-format`] !== 'Online Link');
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = !Boolean(baseValues && baseValues[`${APPLICATION_SUBMISSION}-format`] === 'Online Link');
                        return result;
                    }
                }
            },
            {
                id: 'id-username',
                label: 'ID/Username',
                type: 'text',
                rule: {
                    baseIds: [`${APPLICATION_SUBMISSION}-format`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = !Boolean(baseValues && baseValues[`${APPLICATION_SUBMISSION}-format`] === 'Online Link');
                        return result;
                    }
                }
            },
            {
                id: 'password',
                label: 'Password',
                type: 'text',
                rule: {
                    baseIds: [`${APPLICATION_SUBMISSION}-format`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = !Boolean(baseValues && baseValues[`${APPLICATION_SUBMISSION}-format`] === 'Online Link');
                        return result;
                    }
                }
            },
            {
                id: 'dateCombo',
                label: 'Preferred date of physical media submission',
                type: 'dateRadio',
                span: 12,
                rule: {
                    baseIds: [`${APPLICATION_SUBMISSION}-format`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = !Boolean(baseValues && baseValues[`${APPLICATION_SUBMISSION}-format`] !== 'Physical');
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = !Boolean(baseValues && baseValues[`${APPLICATION_SUBMISSION}-format`] === 'Physical');
                        return result;
                    }
                },
                preField: {
                    id: 'radio-day',
                    label: ' ',
                    type: 'radio',
                    options: [
                        {
                            optID: 'AM',
                            optLabel: 'AM'
                        },
                        {
                            optID: 'PM',
                            optLabel: 'PM'
                        },
                        {
                            optID: 'Full Day',
                            optLabel: 'Full Day'
                        }
                    ]
                },
                mainField: {
                    id: 'main',
                    type: 'date',
                    rule: {
                        baseIds: [`${APPLICATION_SUBMISSION}-format`],
                        required: ({ baseValues }: RuleProps) => {
                            const result = !Boolean(baseValues && baseValues[`${APPLICATION_SUBMISSION}-format`] !== 'Physical');
                            return result;
                        },
                        hidden: ({ baseValues }: RuleProps) => {
                            const result = !Boolean(baseValues && baseValues[`${APPLICATION_SUBMISSION}-format`] === 'Physical');
                            return result;
                        },
                        dateLimit: () => {
                            return { minDate: new Date() };
                        }
                    }
                }
            },
            {
                id: 'attachments',
                label: 'Attachment Upload',
                type: 'file',
                category: 'SupportingDocuments',
                fileTypes: ['.jpeg', '.jpg', '.png', '.bmp', '.mp4', '.mpeg', '.mov', '.pdf', '.xls', '.doc', '.xlsx', '.docx'],
                mimeTypes: [
                    'application/pdf',
                    'application/vnd.ms-excel',
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'application/msword',
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                    // 'text/plain',
                    'image/jpeg',
                    'image/jpg',
                    'image/png',
                    // 'image/gif',
                    'image/bmp',
                    'video/quicktime',
                    'video/mp4',
                    'video/mpeg'
                ],
                rule: {
                    baseIds: [`${APPLICATION_SUBMISSION}-tentative-rating`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${APPLICATION_SUBMISSION}-tentative-rating`] === 'General');
                        return result;
                    }
                }
            },
            {
                id: 'heading-1',
                type: 'label',
                variant: 'h4',
                label: 'Do you need Express Service?',
                span: 12,
                rule: {
                    baseIds: [`${APPLICATION_SUBMISSION}-tentative-rating`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            (baseValues[`${APPLICATION_SUBMISSION}-tentative-rating`] === 'General' ||
                                baseValues[`${APPLICATION_SUBMISSION}-tentative-rating`] === 'Advisory 16')
                        );
                        return result;
                    },
                    previewHidden: true
                }
            },
            {
                id: 'body-1',
                type: 'label',
                label: `• Standard Service processing time will be within 6 - 10 working days from the receipt of the game. 
                            • Express Service processing time will be within 5 working days from the receipt of the game.`,
                span: 12,
                rule: {
                    baseIds: [`${APPLICATION_SUBMISSION}-tentative-rating`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            (baseValues[`${APPLICATION_SUBMISSION}-tentative-rating`] === 'General' ||
                                baseValues[`${APPLICATION_SUBMISSION}-tentative-rating`] === 'Advisory 16')
                        );
                        return result;
                    },
                    previewHidden: true
                }
            },
            {
                id: 'id-type',
                options: [
                    {
                        optID: 'Yes',
                        optLabel: 'Yes Classification fee of $200 applies if the game is rated M18, Refused Classification or Prohibited'
                    },
                    {
                        optID: 'No',
                        optLabel: `No Classification fee of $50 applies if the game is rated M18, Refused Classification or Prohibited`
                    }
                ],
                isRowDisplay: true,
                type: 'radio',
                span: 12,
                rule: {
                    baseIds: [`${APPLICATION_SUBMISSION}-tentative-rating`],
                    required: true,
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            (baseValues[`${APPLICATION_SUBMISSION}-tentative-rating`] === 'General' ||
                                baseValues[`${APPLICATION_SUBMISSION}-tentative-rating`] === 'Advisory 16')
                        );
                        return result;
                    },
                    previewHidden: true
                }
            }
        ],
        rule: {
            baseIds: [`${APPLICATION_SUBMISSION}-tentative-rating`],
            hidden: ({ baseValues }: RuleProps) => {
                const result = Boolean(baseValues && baseValues[`${APPLICATION_SUBMISSION}-tentative-rating`] === 'General');
                return result;
            }
        }
    }
];
